console.log('Consent handler loaded');

const BORLABS_SYNC_KEY = 'borlabsLastSyncedConsent';

const MAX_WAIT_TIME = 10000; // 10 seconds
const MAX_RETRIES = 2; // Maximum number of retries
const RETRY_INTERVAL = 200; // 200 milliseconds

const pollUntil = (conditionFunction, onSuccess, onFailure, timeout = MAX_WAIT_TIME) => {
	const startTime = Date.now();
	const interval = setInterval(() => {
		console.log('Polling for condition...');
		if (conditionFunction()) {
			clearInterval(interval);
			onSuccess();
		} else if (Date.now() - startTime > timeout) {
			clearInterval(interval);
			console.error('Timeout reached while waiting for condition');
			if (onFailure) {
				onFailure();
			}
		}
	}, RETRY_INTERVAL);
};
const publishEventToShopifyFromParam = (param) => {
	const eventName = 'post:paramsDataId';
	const eventData = {
		event: eventName,
		data: param,
	};
	pollUntil(
		() => window.Shopify && window.Shopify.analytics,
		() => {
			window.Shopify.analytics.publish(eventName, eventData);
			console.log('Shopify object is available, event published:', eventName, eventData);
		},
		() => {
			console.error('Failed to publish event to Shopify after retries');
		},
	);
};
const getCookie = (key) => {
	const decodedCookie = decodeURIComponent(document.cookie);
	const ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		const cKey = c.split('=')[0].trim();

		if (cKey === key) {
			const value = c.split('=')[1].trim();
			console.log(`Cookie found -> ${cKey}=${value}`);
			return value;
		}
	}
	return '';
};
const getBorlabsCookie = () => {
	const cookieValue = getCookie('borlabs-cookie');
	if (!cookieValue) {
		console.log('No borlabs-cookie found');
		return null;
	}
	try {
		const decoded = decodeURIComponent(cookieValue);
		const parsed = JSON.parse(decoded);
		console.log('Borlabs cookie parsed:', parsed);
		return parsed;
	} catch (error) {
		console.error('Error parsing borlabs-cookie:', error);
		return null;
	}
};
const mapBorlabsToShopifyConsent = (borlabsData) => {
	if (!borlabsData || !borlabsData.consents) {
		return null;
	}
	const statisticsConsents = borlabsData.consents.statistics;
	const marketingConsents = borlabsData.consents.marketing;
	const requiredVendors = window.borlabsMarketingVendors || ['meta', 'google'];
	return {
		analytics: Array.isArray(statisticsConsents) && statisticsConsents.includes('mapp'),
		marketing:
			Array.isArray(marketingConsents) && requiredVendors.every((vendor) => marketingConsents.includes(vendor)),
		sale_of_data: false,
	};
};
const setShopifyConsent = (consentData, source) => {
	pollUntil(
		() => window.Shopify && typeof window.Shopify.customerPrivacy === 'object',
		() => {
			window.Shopify.customerPrivacy.setTrackingConsent(consentData, () => {
				console.log(`Consent set via ${source}`);
			});
			setTimeout(() => {
				if (!sessionStorage.getItem('consentReloadedOnce')) {
					console.warn('Fallback: consent event not received, forcing reload');
					sessionStorage.setItem('consentReloadedOnce', '1');
					window.location.reload();
				}
			}, 4000); // 4 seconds fallback
		},
		() => {
			console.error('Failed to set consent data after retries customer privacy not found');
		},
	);
};
const setShopifyConsentFromBorlabs = () => {
	const borlabsData = getBorlabsCookie();
	if (!borlabsData) {
		console.log('No borlabs cookie data available');
		return false;
	}
	console.log('Borlabs cookie data:', borlabsData);
	const consentData = mapBorlabsToShopifyConsent(borlabsData);
	if (!consentData) {
		console.log('Could not map borlabs consent data');
		return false;
	}
	console.log('Mapped borlabs consent:', consentData);
	// Only sync if the borlabs consent has changed since the last time we synced.
	// This preserves any consent changes the customer made inside Shopify.
	// Normalize before stringifying: sort object keys and sort each array so that
	// order differences (e.g. ["meta","google"] vs ["google","meta"]) never cause a false mismatch.
	const normalizeConsents = (consents) =>
		Object.fromEntries(
			Object.keys(consents)
				.sort()
				.map((key) => [key, [...consents[key]].sort()]),
		);
	const currentConsentsJSON = JSON.stringify(normalizeConsents(borlabsData.consents));
	const lastSyncedConsentsJSON = localStorage.getItem(BORLABS_SYNC_KEY);
	console.log('Current consents JSON:', currentConsentsJSON);
	console.log('Last synced consents JSON:', lastSyncedConsentsJSON);
	if (currentConsentsJSON === lastSyncedConsentsJSON) {
		console.log('Borlabs consent unchanged since last sync, skipping Shopify write');
		document.dispatchEvent(new CustomEvent('consent:already-synced', { bubbles: true }));
		return false;
	}
	localStorage.setItem(BORLABS_SYNC_KEY, currentConsentsJSON);
	setShopifyConsent(consentData, 'borlabs cookie');
};
document.addEventListener('consent:params', function (event) {
	console.log('Consent param event received:', event.detail);

	const urlParams = event.detail.params;
	// marketing technology params
	const paramIDs = ['gbraid', 'wbraid', 'gclid', 'fbclid', 'utm_source', 'everID'];
	const idParamFound = paramIDs.find((param) => urlParams.has(param));
	if (idParamFound) {
		const param = {
			name: idParamFound,
			value: urlParams.get(idParamFound),
		};
		publishEventToShopifyFromParam(param);
	} else {
		console.log('No marketing param found');
	}
	// Read consent from borlabs cookie
	pollUntil(
		() => window.Shopify && typeof window.Shopify.loadFeatures === 'function',
		() => {
			console.log('Shopify consent API is available');
			window.Shopify.loadFeatures(
				[
					{
						name: 'consent-tracking-api',
						version: '0.1',
					},
				],
				(err) => {
					if (err) {
						console.error('Error loading Shopify features:', err);
						return;
					}
					console.log('Shopify consent-tracking feature loaded');
					setShopifyConsentFromBorlabs();
				},
			);
		},
		() => {
			console.error('Failed to load Shopify consent API after retries');
		},
	);
});

document.addEventListener('visitorConsentCollected', (event) => {
	console.log('Consent set', event.detail);
	const consentData = {
		analyticsAllowed: event.detail?.analyticsAllowed || false,
		marketingAllowed: event.detail?.marketingAllowed || false,
		preferencesAllowed: event.detail?.preferencesAllowed || false,
	};
	if (!window._saleOfDataOverrideApplied) {
		// Re-set consent with sale_of_data explicitly false (Shopify banner doesn't include it)
		window._saleOfDataOverrideApplied = true;
		setShopifyConsent(
			{
				analytics: consentData.analyticsAllowed,
				marketing: consentData.marketingAllowed,
				sale_of_data: false,
			},
			'shopify banner (sale_of_data override)',
		);
		return;
	} else {
		window._saleOfDataOverrideApplied = false;
	}
	// reload the page to apply the consent
	if (sessionStorage.getItem('consentReloadedOnce') === '1') return;
	sessionStorage.setItem('consentReloadedOnce', '1');
	window.location.reload();
});
